import codes from '../errors/codes';

class PageNotFoundError extends Error {
  constructor(route) {
    super('page not found');

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PageNotFoundError);
    }

    this.name = 'PageNotFoundError';
    this.code = codes.pageNotFoundError;
    this.data = {
      route,
    };
  }
}

export default PageNotFoundError;
